/* eslint-disable react/prop-types */
import React from 'react';
import './iconBox.scss';
import { isArray } from 'lodash';

interface IconBoxProps {
  text?: string | string[] | undefined;
  color?: string;
  textColor?: string;
  icon?: string;
  title?: string;
}

const renderText = (text: string | string[]) => {
  if (!isArray(text)) {
    const tab = text.split(' ');
    if (tab.length < 2) return <div className="label">{text}</div>;
    return (
      <div>
        <div className="label1">{tab[0]}</div>
        <div className="label">{tab[1]}</div>
      </div>
    );
  }
  return <div className="label">{text}</div>;
};

export const IconBox: React.FC<IconBoxProps> = ({
  text,
  color,
  icon,
  textColor,
  title,
}) => (
  <div>
    {text ? (
      <div
        title={title}
        className="avatar"
        style={{ backgroundColor: `${color}`, color: `${textColor}` }}
      >
        {renderText(text)}
      </div>
    ) : (
      ''
    )}
  </div>
);

IconBox.defaultProps = {
  color: '#c1c5c9',
  textColor: '#000000',
  text: '',
  icon: '',
};

export default IconBox;
